<template>
  <div v-html="message"></div>
  <form @submit.prevent="resolve(pwd)">
    <p>
      <PasswordInput v-model="pwd"/>
    </p>
    <div class="vueforms-dialog-buttons-bottom">
      <hy-button type="submit">Durchführen</hy-button>
      <hy-button type="reset" @click="resolve(false)">Schließen</hy-button>
    </div>
  </form>
</template>

<script>
import { ref } from 'vue';
import PasswordInput from '../base/PasswordInput.vue';
import HyButton from '../../basic-components/HyButton.vue';


export default {
  components: { PasswordInput, HyButton },
  props: {
      resolve: Function,
      reject: Function,
      message: {
          type: String,
          default: "Um die Änderungen durchzuführen, müssen Sie Ihr Passwort erneut eingeben."
      }
  },
  inheritAttrs: false,
  setup(props) {
      let pwd = ref("");
      return {
          pwd
      };
  },
}
</script>

<style>

</style>